import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { GraphqlModule } from '@myclubrewards/graphql';
import { EarnRedeemRoutingModule } from './earn-redeem-routing.module';
import { EarnRedeemComponent } from './components/earn-redeem/earn-redeem.component';
import { AdminSharedModule } from '../../../shared/admin-shared.module';

export const Components = {
  EarnRedeemComponent: EarnRedeemComponent,
};

@NgModule({
  imports: [
    CommonModule,
    HttpClientModule,
    GraphqlModule,
    EarnRedeemRoutingModule,
    AdminSharedModule,
  ],
  declarations: [Components.EarnRedeemComponent],
  exports: [Components.EarnRedeemComponent],
})
export class EarnRedeemModule {}
